
export default {
  cn: {
    text: {
      doing: '加载中',
      sysError: '系统错误',
      view: '查看',
      list: '列表',
      count: '统计',
      action: '动作',
      create: '新增',
      createCustom: '定制',
      createCustom2: '样衣',
      createBulk: '大货',
      createQuick: '快捷',
      edit: '编辑',
      delete: '删除',
      remove: '移除',
      close: '关闭',
      submit: '提交',
      save: '保存',
      back: '返回',
      register: '免费注册',
      login: '登  录',
      returnLogin: '返回登录',
      noimage: '无图片',
      noimageMini: '无',
      baseInfo: '基本信息',
      productInfo: '产品信息',
      name: '名称',
      more: '更多',
      noData: '暂无数据',
      // asyncInv: '是否同步库存',
      sequence: '排序',
      seq: '序号',
      explain: '说明',
      reference: '变量',
      template: '模版',
      qrCode: '二维码',
      perfectInformation: '完善公司信息',
      createAt: '创建日期',
      createName: '创建人',
      workflowState: '状态',
      remark: '备注',
      batchRemark: '批量备注',
      quantity: '数量',
      special: '特殊',
      owner: '所属',
      ownerName: '所属人',
      time: '时间',
      date: '日期',
      handle: '经办',
      handOverAt: '交货日期',
      handOverAt2: '交期',
      handOverAtDateMinus: '距交期',
      printAt: '打印日期',
      flag: '旗帜',
      content: '内容',
      serialNo: '单号',
      log: '日志',
      unPrint: '未打印',
      stop: '停',
      paused: '停',
      startAt: '开始日期',
      endAt: '结束日期',
      startTimeAt: '开始时间',
      endTimeAt: '结束时间',
      type: '类型',
      total: '合计',
      detail: '详细',
      lineItem: '明细',
      settlementLineItem: '账单明细',
      qrcode: '二维码',
      printInfo: '打印情况',
      month: '月',
      edition: '版本',
      orderType: '订单类型',
      search: '查询',
      number: '数字',
      price: '价格',
      price2: '单价',
      subtotal: '小计',
      amount: '总金额',
      year: '年',
    },
    printInfos: {
      yes: '已打印',
      no: '未打印',
    },

    rules: {
      required: '请输入{0}',
      select: "请选择{0}",
      selected: "已选择过该{0}",
      error: '{0}错误',
      exist: '{0}存在',
      filledIn: '已填写过该{0}',
      regex: '请输入正确的{0}',
      mustFillSimple: '*{0}',
      mustFill: '{0} 必填',
      startAt: '{0}开始',
      endAt: '{0}结束',
      create: '新增{0}',
      edit: '编辑{0}',
      min: '{0}-最小',
      max: '{0}-最大',
      pagerTotal: '共 {0} 条记录'
    },
    boolean: {
      true: '是',
      false: '否'
    },
    menu: {
      profile: '我的信息',
      company: '公司信息',
      logout: '退出',
      perferences: '设置',
      users: '子账户',
      shops: '店铺',
      categories: '分类',
      categoriesProduct: '产品分类',
      categoriesServe: '服务分类',
      sizes: '规格',
      units: '单位',
      colors: '颜色',
      brands: '品牌',
      payMethods: '收付款方式',
      scheduleTypes: '预约类型',
      settings: '系统设置',
      downloads: '文件下载',
      products: '产品',
      services: '服务',
      inventories: '现货',
      customers: '客户',
      stockIns: '入库单',
      stockOuts: '出库单',
      allocates: '调拨单',
      damages: '报损单',
      schedules: '预约管理',
      rentPackages: '套餐',
      packages: '套餐',
      bargains: '订单',
      suppliers: '供应商',
      authTemplates: '权限模版',
      sources: '来源类型',
      rentTemplates: '订单模版',
      deliveries: '发货单',
      reports: '报表',
    },
    itemTypes: {
      rent: '租赁单',
      clean: '清洗单',
      service: '服务单',
      custom: "定制销售单",
      available: "现货销售单",
      order: '销售单',
    },
    login: {
      accountLogin: '账号登录',
      vfcodeLogin: '验证码登录',
    },
    editionRegisters: {
      // af: '接单版，我用来接客户下单',
      // bf: '下单版，我用来给供应商下单'
      af: '接单版，接客户下单',
      bf: '下单版，给供应商下单'
    },
    boolean: {
      true: '是',
      false: '否'
    },
    user: {
      account: '账号',
      password: '密码',
      phone: '手机号',
      vfcode: '验证码',
      name: '姓名',
      admin: '管理员',
      checkPassword: '确认密码',
      shop: '所属店铺',
      voidInfo: '失效情况',
      authorize: '授权情况',
      token: '令牌'
    },
    authorizes: {
      authorized: '已授权',
      unAuthorize: '未授权',
      void: '失效',
      noVoid: '未失效',
      admin: '管理员'
    },
    tenant: {
      name: '公司名称',
      industry: '所在行业',
      country: '国家/地区',
      province: '省份',
      city: '城市',
      address: '地址',
      identifier: '公司编号',
      logo: 'LOGO',
      introduction: '公司介绍',
      acceptName: '接单名称',
      placeName: '下单名称',
      expirationAt: '系统到期',
      mainProducts: '主营产品',
    },
    payMethodTypes: {
      sale: '销售',
      balance: '充值',
      both: '销售、充值',
    },
    scheduleType: {
      analyse: '该类预约可能转化成订单'
    },
    config: {
      // nearDays: '近交期(天)',
      // dealType: '订单处理方式',
      // publishMessage: '公开我公司信息到产业联盟,让别人能找到我',
      loginNotify: '异地登录通知',
      // financeVerifyStrict: '订单审核强介入（审核后订单才能走流程处理）',
      // deliveryStrict: '欠款发货需审核',
      // autoAsyncPurchase: '订单修改，自动同步外采单及供应商相关订单',
      // outgoingQualityControl: '现货出货质检',
      createOrderFixShop: '录单只能录自己所属店铺',
      // invNeedPickPush: '订单收货质检、发货后手动入库、出库',
      // mmsInvUseCash: '物料发料时候多发料进库存余量',
      // mesSchedule: '启用生产排程功能',
    },
    download: {
      downloadInfo: '下载情况',
      downloaded: '已下载',
      unDownload: '未下载',
      downloadAt: '下载日期'
    },
    downloadFileStates: {
      downloading: '生成中',
      finish: '已生成',
      uploadError: '失败', //'上传失败',
      generateError: '失败', //'生成失败',
      fileNotFound: '失败' //'生成失败',
    },
    product: {
      productNo: '货号',
      name: '名称',
      category: '分类',
      unit: '单位',
      purchaseUrl: '外采链接',
      color: '颜色',
      size: '规格',
      images: '图片',
      brand: '品牌',
      salesPrice: '售价',
      costPrice: '成本价',
      rentPrice: '租赁价',
      introduction: '描述',
      life: '生命周期',
      attachment: '附件',

      productNoRepeat: '异常产品',
      supplierPrice: '供应商价格',
      supplierProductNo: '供应商货号',
      defaultSupplier: '默认供应商',
      productSupplier: '产品供应商',
    },
    yearInfos: {
      yes: '周期内',
      no: '已过期',
    },

    service: {
      productNoRepeat: '异常服务',
    },
    overLifes: {
      yes: '已过期',
      no: '未过期',
    },
    shop: {
      timeSlot: '时间段',
      fittingRoom: '试衣间',
      startTime: '起始时间',
      endTime: '结束时间',
    },

    inventory: {
      quantity: '现货数量',
      // storeQuantity: '库存量',
      totalQuantity: '总现货量',
      totalLock: '锁定数量',
      warnQuantity: '报警数量',
      // alertQuantity: '报警量',
      invLockQty: '现货/锁定',
      // lock: '锁定',
      remainQuantity: '剩余数量',
      pendingStockInQty: '待入库数量',
      onTheWayQty: '在途量',
      // inventoryInfo: '库存情况',
      inventoryInfoNoExist: '现货不存在',
      // lastCheckAt: '最后盘点日期',
      // unCheck: '未盘点',
      // actualQuantity: '实际量',
    },
    stock: {
      viewStockInOutDetail: '查看所有出入库明细',
      productNoQty: '货号数',
      productAmount: '产品总量',
      stockInType: '入库类型',
      stockOutType: '出库类型',
      type: '出入库类型',
      stockInQuantity: '入库数量',
      stockOutQuantity: '出库数量',
      totalQuantity: '总数量',
      associateSerialNo: '相关单号',
      serialNoIn: '入库单号',
      serialNoOut: '出库单号',
      createAtIn: '入库日期',
      createAtOut: '出库日期',
      ownerOut: '出库人',
      ownerIn: '入库人',

    },
    stockInType: {
      init: '初始化',
      check: '盘点',
      allocate: '调拨',
      other: '其他',
      rent: '租赁',
      clean: '清洗',
      salesProcess: '定制销售',
      returnBack: '退货',
    },
    stockOutType: {
      check: '盘点',
      allocate: '调拨',
      damage: '报损',
      other: '其他',
      rent: '租赁',
      clean: '清洗',
      salesPrepared: '现货销售',
      salesProcess: '定制销售',
    },
    countDay: {
      today: '今天',
      yesterday: '昨天',
      week: '本周',
      lastweek: '上周',
      month: '本月',
      lastmonth: '上月'
    },
    damage: {
      remark: '报损原因',
      voucher: '报损凭证',
      verifyInfo: '审核信息',
      rejectReason: '拒绝原因'
    },
    damageWorkflowStates: {
      newly: '待审核',
      agreed: '同意',
      rejected: '拒绝',
      outed: '出库'
    },
    allocate: {
      serialNo: '调拨单号',
      applyShopInfo: '申请方信息',
      acceptShopInfo: '受理方信息',
      applyRemark: '申请说明',
      acceptRemark: '受理备注',
      applyShopName: '申请店铺',
      acceptShopName: '受理店铺',
      allocateType: '调拨类型',
      applyAt: '申请时间',
      applyShop: '申请方',
      applyName: '申请人',
      acceptAt: '受理时间',
      acceptShop: '受理方',
      acceptName: '受理人',
      allocateCountType: '操作',
      rejectReason: '拒绝原因'
    },
    allocateWorkflowState: {
      applying: '新的',
      outed: '出库',
      rejected: '拒绝',
      ined: '入库',
      cancel: '取消',
      picking: '待出库',
      pushing: '待入库',
    },
    allocateTypes: {
      in: '申请调入',
      out: '申请调出'
    },
    allocateCountTypes: {
      pendingIn: '待入库',
      pendingOut: '待出库'
    },
    customer: {
      serialNo: '客户编号',
      name: '姓名',
      phone: '电话',
      email: 'QQ/微信',
      zipcode: '邮编',
      source: '来源类型',
      sourceRemark: '具体来源',
      jyAccount: '有简赢账户',
      nojyAccount: '无简赢账户',
      settleType: '现结',
      balance: '账户余额',
      balance2: '余额',
      phoneSerialNo: '电话/编号',
      phoneSerialNoName: '电话/编号/名字',
      phoneName: '电话/名字',
      company: '公司名称',
      customerInfo: '客户信息',
      addressInfo: '地址信息',
      follow: '跟踪',
      rechargeAmount: '充值金额',
      isMember: '会员',
      follows: '跟踪',
      suggestName: '介绍人',
      weddingDay: '婚期',
    },
    supplier: {
      replaceDeliver: '代发货',
      url: '网址',
      price: '外采单价',
      showTerminalInfo: '可以显示终端客户名称、售价',
      namePhone: '名称 电话',
    },
    schedule: {
      title: '标题',
      type: '类型',
      planAt: '时间',
      planAt2: '计划日期',
      state: '状态',
      dutyName: '值班人员',
      scheduleInfo: '日程信息',
      year: '提醒年',
      fit: '试衣',
      fitName: '试衣间',
      makeup: '化妆',
      makeupName: '化妆师',
    },
    scheduleStates: {
      undo: '未做',
      done: '已完成', // “转化”   //做了买了
      canceled: '取消',
      giveUp: '放弃' // 做了没买
    },
    rentPackage: {
      config: '套餐配置',
      showWorkbench: '展示在工作台',
      image: '封面图',
    },
    rent: {
      serialNo: '单号',
      rentAt: '使用日期',
      rentAtHandOverAt: '使用日期/交期',
      receivePaymentInfo: '收款信息',
      total: '总价',
      actualReceive: '实收',
      deposit: '押金',
      depositInfo: '押金信息',
      serviceName: '服务商',
      serviceAmount: '清洗费用',
      productQty: '产品数',
    },
    rentItem: {
      serialNo: '项号',
      price: '租赁单价',
      outName: '出库人',
      finishName: '完成人',
      finishAt: '完成日期',
      finishRemark: '完成备注',
      inRemark: '入库备注',
      outRemark: '出库备注',

      cancelInfo: '取消情况',
      cancelName: '操作人',
      cancelAt: '取消日期',
      cancelReason: '取消原因',
      returnInfo: '退货情况',
      returnName: '操作人',
      returnAt: '操作日期',
      returnReason: '退货原因',
      hasGood: '货退回',

    },
    order: {
      productPrice: '产品原价',
      hurry: '加急',
      hurrySimple: '急',
      dealAt: '处理日期',
      dealtAt: '处理完成日期',
      finishAt: '发货日期',

      receiveName: '收货人',
      receiveAt: '收货日期',
      quantityName: '质检人',
      quantityAt: '质检日期',
      reworkName: '返工人',
      reworkAt: '返工日期',
    },
    rentStates: {
      newly: '新的',
      preparing: '备货中',
      prepared: '备货完毕',
      outed: '出库',
      finished: '完成',
      canceled: '取消',
    },
    orderStates: {
      newly: '新的',
      preparing: '备货中',
      prepared: '备货完毕',
      processing: '生产中',
      received: '已收货',
      qualitied: '已质检',
      finished: '交货完成',
      canceled: '取消',
      returned: '退货',
      reworking: '返工中',
    },
    rentOrderStates: {
      newly: '新的',
      outed: '出库',
      preparing: '备货中',
      prepared: '备货完毕',
      processing: '生产中',
      received: '已收货',
      qualitied: '已质检',
      finished: '完成', //交货完成
      canceled: '取消',
      returned: '退货',
      reworking: '返工中',
    },


    clean: {
      serialNo: '清洗单号',
      rentAt: '清洗日期',
    },
    cleanItem: {
      serialNo: '清洗单项号',
    },


    payment: {
      total: '金额',
      total2: '已收款',
      payMethod: '方式',
      paidAt: '日期',
      explain: '说明',
      voucher: '凭证',
      receiveName: '收款人',
      //
      receive: '收',
      differ: '欠',
      ignore: '抹',
      settled: '已结清',
      leave: '余',
      differReceive: '欠收',
      leavePayAmount: '结余',
      diffAmount: '差额',
      //
      debt: '欠款',
      depositDebt: '押金未退',
    },
    deposit: {
      total: '押金',
      payMethod: '押金方式',
      remark: '押金备注',
      voucher: '押金凭证',
      paidAt: '押金日期',
    },
    depositReturn: {
      total: '退押金',
      payMethod: '退款方式',
      remark: '退款备注',
      voucher: '退款凭证',
      paidAt: '退款日期',
      ownerName: '退款人',
    },

    deliveryTypes: {
      express: '快递',
      carry: '送货',
      take: '自提',
      agent: '货代',
      signDeliver: '标记发货'
    },
    delivery: {
      express: '快递公司',
      tracking: '运单号',
      deliverCost: '费用',
      sender: '送货人',
      expressSender: '快递公司 送货人',
      deliveryAt: '发货日期',
      deliverType: '发货类型',

    },
    reports: {
      scheduleStatistics: '预约分析报表',
      scheduleFinishStatistics: '预约完成情况报表',
      rentSourceStatistics: '订单来源分析报表',
      saleStatistics: '订单统计报表',
      cleanCosts: '清洗费用报表',
      hotProductNoStatistics: '受欢迎款式排名',
      hotPackageStatistics: '受欢迎套餐排名',
      supplierContributionStatistics: '供应商贡献报表',




      percent: '百分比',
      transQuantity: '转化',
      transPercent: '转化率',
      finishPercent: '完成百分比',
      cancelPercent: '取消百分比',
      giveUpPercent: '放弃百分比',
      orderQuantity: '订单量',
      quantityPercent: '数量百分比',
      amount: '订单额',
      amountPercent: '订单额百分比',
      rentQuantity: '租赁货次',
      rentQuantity2: '租赁次',
      rentAmount: '租赁金额',
      saleQuantity: '销售件数',
      saleAmount: '销售金额',
      userName: '人员',
      payAmount: '已收款',
      remainPayAmount: '未收尾款',
      remainDepositAmount: '未退押金',
      serviceQuantity: '服务人数',
      customQuantity: '定制销售件数',
      availableQuantity: '现货销售件数',
    },
    flags: {
      red: '红旗',
      orange: '橙旗',
      yellow: '黄旗',
      green: '绿旗',
      cyan: '青旗',
      blue: '蓝旗',
      purple: '紫旗',
      clear: '清除旗帜'
    },
    weeks: {
      Monday: '周一',
      Tuesday: '周二',
      Wednesday: '周三',
      Thursday: '周四',
      Friday: '周五',
      Saturday: '周六',
      Sunday: '周日'
    },
    weekDays: {
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六',
      0: '周日'
    },

    newImportRent: {
      excelTitle: 'Excel文件列头：订单号(必填)，所属店铺(必填)，客户电话(必填)，客户名称，客户来源，收货省份，收货城市，收货地址，备注，押金，押金方式，押金说明，收款额(必填)，收款方式(必填)，收款说明，订单项类型(必填)，交货日期，开始日期(必填*)，结束日期(必填*)，货号(必填)，颜色，规格，数量(必填)，单位，单价(必填)，分类(必填)，订单项备注。',
      beCarefulShop: '店铺是设置中店铺名称，匹配不到则忽略这条数据',
      beCarefulRentType: '订单项类型是现货销售单、定制销售单、租赁单、服务单、清洗单',
      beCarefulStartAt: '如果订单类型是租赁单、清洗单，开始日期、结束日期必须填写',
      beCarefulPaymentMethode: '收款方式是设置中收款方式名称，匹配不到则默认第一个',
    },
    prompt: {
      //登陆注册
      accountNotExist: '账户不存在',
      sendVerificationCode: '发送验证码',
      phoneRegistered: '该手机号已注册',
      registerSuccess: '注册成功',
      regexPassword: '密码需要至少8位，大写小写数字特殊字符混合',
      passwordPrompt: '密码需要至少8位，大写小写数字特殊字符混合',
      //
      perfectInformationSuccess: '完善成功',
      addMorePrompt: '单次提交不能超过10条记录',
      //
      addSuccess: '新增成功',
      delSuccess: '删除成功',
      editSuccess: '编辑成功',
      verifySuccess: '审核成功',
      saveSuccess: '保存成功',
      confirmDelete: '确认删除？',
      confirmStockOut: '确认出库？',
      confirmStockIn: '确认入库？',
      confirmFinish: '确认完成？',
      downloadPrompt: '请稍后到 下载文件 中下载',
      downloadErr: '下载失败',
      actionSuccess: '操作成功',
      //
      passwordAgain: '请再次输入密码',
      passwordDiffer: '两次输入密码不一致',
      logoExplain: 'LOGO建议尺寸64px*64px，小于500K，格式jpg、png',
      dataUserAuth: '用户',
      dataUserAuthExplain: '该账号可以看以下人员的相关数据',
      dataWmsView: '现货查看',
      dataWmsViewExplain: '该账号可以查看的店铺',
      dataWmsManage: '现货管理',
      dataWmsManageExplain: "该账号可以管理操作的店铺",
      authSuccess: '授权成功',
      //
      alphabetNumber: '数字、字母',
      atLastOneAlphabet: '至少一个字母',
      atLeastFillInOneValidData: '至少填写一条有效数据',
      setInvalid: '确认设置失效?',
      setSuccess: '设置成功',
      authQtyBeyond: '权限人员已达上限，请联系客服购买',
      errorMessage: '存在错误提示',
      noOtherType: '暂无其他类别',
      atLeastSelectOneData: '至少选择一条数据',
      atLeastSelectOneProduct: '至少选择一个产品',
      atLeastAddOneProduct: '至少添加一个产品',
      downloadSuccess: '下载成功',
      linkImageExplain: '每行一个图片链接，用回车键换行',
      downloadDataRange100000: '选择记录需大于0小于100000',
      noColorSize: '选择产品没有颜色规格',
      productNoAsyncInvExplain: '同步现货后，可能会导致已存在货号的订单不能发货出库，请谨慎操作！！！',
      plaseConfirmAsyncInv: '请确认同步现货',
      tranSuccess: '转化成功',
      stockOutSuccess: '出库成功',
      stockInSuccess: '入库成功',
      stockInAllSuccess: '归还成功',
      damageSuccess: '报损成功',
      beyondMaxInvQty: '数量大于最大现货数量',
      beyondMaxStockOutQty: '出库数量大于最大可出库数量',
      beyondMaxDamageQty: '报损数量大于最大可报损数量',
      beyondMaxAllocateQty: '调拨数量大于最大可调拨数量',
      beyondMaxAllocateQty2: '要货数量大于最大可要货数量',
      beyondMaxCleanQty: '要货数量大于最大可清洗数量',

      applySuccess: '申请成功',
      updateManualLockQtySuccess: '修改锁定量成功',
      placeSelectProductNo: '请先选货号',
      hasBeenSelectProduct: '已选择过该产品',
      atLeastOneDataFill: '至少填写一条数据',
      checkSuccess: '盘点成功',
      rejectSuccess: '拒绝成功',
      stockInSuccess: '入库成功',
      alphabetNumberLine: '字母、数字、-',
      hasBeenAdded: '已添加过该账号',
      notAddOneself: '不能添加自己或子账户',
      notAddSubaccounts: '不能添加子账户',
      noAccount: '没有简赢账号',
      hasAccount: '有简赢账户,请去有简赢账户新增',
      createSupplierInput: '输入简赢账号，供应商的手机号码',
      distributiveSuccess: '分配成功',
      signSuccess: '标记成功',
      cancelSuccess: '取消成功',
      returnSuccess: '取消成功',
      noShops: '没有店铺',
      selectShop: '先选择店铺',
      selectDate: '先选择日期',
      finishSuccess: '完成成功',
      giveUpSuccess: '放弃成功',
      outInvInfoNotExist: '现货不存在该产品',
      atLeastOneDataCanBatchAcceptRecords: '至少选择一条受理仓是我管理的可受理的调拨单',
      copySuccess: '复制成功',
      plaseSelectShop: '请选择店铺',
      returnDepoistSuccess: '退押金成功',
      depoistToPaySuccess: '押金转收款成功',
      rentTemplatePrompt: '如果添加单项的属性，必须添加订单里面的${订单项}属性，${订单项}的位置即单项的位置',
      loadFinish: '已经加载完',
      generateCleanSuccess: '生成清洗单成功',
      noSetFittingRooms: '暂无设置试衣间',
      noSetTimeSlots: '暂无设置试时间段',
      noSetFittingRooms: '未设置试衣间',
    },
    placeholder: {
      namePhone: '姓名 账号',
      productNoMatchingInv: '货号匹配现货产品',
      namePhone: '名称、电话',
      createCustomerInput: '输入简赢账号，客户的手机号码',
      serialNoInnerSerialNoCustomer: '单号 内部单号 客户',
      serialNoCustomer: '单号 客户',
      serialNoTracking: '单号 运单号',
    },
    action: {
      sendVfcode: '发送验证码',
      editPassword: '修改密码',
      resetPassword: '重置密码',
      setInvalid: '设置失效',
      authData: '数据授权',
      authAction: '操作授权',
      recovery: '恢复',
      auth: '权限',
      print: '打印',
      printTag: '打印吊牌',
      printBaseInfo: '打印基本信息',
      printQrCode: '打印二维码',
      printList1: '列表打印1',
      printList2: '列表打印2',
      printRent: '打印租赁单',
      printClean: '打印清洗单',
      download: '下载',
      downLoadChecked: '勾选下载',
      downLoadSearch: '搜索下载',
      downLoadCheckedWithImg: '勾选下载(带图片)',
      downLoadSearchWithImg: '搜索下载(带图片)',
      checkAll: '全选',
      select: '选 择',
      setDefaultSupplier: '设置默认供应商',
      import: '导入',
      linkImage: '图片链接',

      productAsyncInv: '货号已修改，是否同步现货',
      stockIn: '入库',
      stockIn2: '还件',
      stockOut: '出库',
      stockOut2: '出件',
      damage: '报损',
      allocateOut: '申请调出',
      allocateIn: '申请调入',
      allocateApplayIn: '申请要货',
      manualLockQuantity: '手动锁定现货',
      inventoryCheck: '现货盘点',
      check: '盘点',
      importInventory: '盘点导入',
      addProduct: '添加产品',
      addCustom: '添加定制产品',
      addAvailable: '添加现货产品',
      addRent: '添加租赁单',
      addService: '添加服务单',
      addClean: '添加清洗单',
      addOrder: '添加销售单',
      exportAll: '现货快照',
      accept: '受理',
      reject: '拒绝',
      agree: '同意',
      yuyue: '预约',
      distributiveOwner: '分配拥有人',
      flag: '标旗帜',
      payment: '收款',
      paymentReturn: '退款',
      addReceiveAndPayment: '收款/退款',
      addDeposit: '添加押金',
      copy: '复制',
      place: '下单',

      finishDone: '完成',
      finishGiveUp: '放弃',
      cancel: '取消',
      return: '退货',
      addFollow: '添加跟踪',
      tranCustomer: '完善客户信息',
      tranPlace: '转化下单',
      addConfig: '添加类别',
      createCategory: '新增类别',
      createProductCategory: '新增产品类别',
      createServiceCategory: '新增服务类别',
      addConfigItem: '添加产品',
      returnDeposit: '退押金',
      depoisToPay: '押金转收款',
      finish: '完成',
      setCategory: '设置分类',
      searchSchedule: '档期',
      searchUsableBySchedule: '查可用产品',
      createSchedule: '新增预约',
      select: '选择',
      availableDelivery: '现货交付',
      prepare: '备货',
      prepareRent: '去备货',
      prepared: '备货完毕',
      delivery: '发货',
      deliveryOut: '发货/出库',
      deliveryOut2: '发货/出件',
      deliveryAll: '发货',
      deliveryItem: '发货',
      processing: '去生产',
      receive: '收货',
      quality: '质检',
      rework: '返工',
      receiveAndQuality: '收货并质检',
      clickShowMore: '点击显示更多',
      generateClean: '生成清洗单',
      synWeddingDay: '同步结婚纪念日',
      rentCalendar: '租赁日历',
    },
    newImport: {
      excelTemplate: 'Excel导入模板',
      beCareful: '注意',
      beCarefulMustFill: '必填项不填写，则忽略这条数据',
      results: '导入结果',
      clickDownload: '点击下载'
    },
    newImportProduct: {
      excelTitle: 'Excel文件列头：货号(必填)，名称，分类，品牌，单位(必填)，成本价(必填)，售价(必填)，租赁价(必填)，颜色，规格，图片，描述、寿命',
      beCarefulCategory: '分类是设置中产品分类名称',
      beCarefulBrand: '品牌是设置中产品品牌名称',
      beCarefulColor: '颜色列填写的是该产品所有颜色，每个之间用英文分号(;)分割',
      beCarefulSize: '规格列填写的是该产品所有规格，每个之间用英文分号(;)分割',
      beCarefulImages: '图片列放的是图片链接，多个链接用英文分号(;)分割',
    },
    newImportInventory: {
      excelTitle: 'Excel文件列头：货号(必填)，颜色，规格，数量(必填)、备注',
    },
    newImportCustomer: {
      excelTitle: 'Excel文件列头：账户/电话(必填)，客户编号(必填)，姓名(必填)，公司名称，Email，类型(wholesale/retail)，来源，国家，省份，城市，地址，邮编，备注',
      beCarefulType: '类型分为批发和零售，批发填写wholesale，零售填写retail'
    },
    countries: {
      CN: 'China(中国)',
      AD: 'Andorra(安道尔)',
      AE: 'United Arab Emirates(阿拉伯联合酋长国)',
      AF: 'Afghanistan(阿富汗)',
      AG: 'Antigua and Barbuda(安提瓜和巴布达)',
      AI: 'Anguilla(安圭拉岛)',
      AL: 'Albania(阿尔巴尼亚)',
      AM: 'Armenia(亚美尼亚)',
      AN: 'Netherlands Antilles(荷属安的列斯群岛)',
      AO: 'Angola(安哥拉)',
      AQ: 'Antarctica(南极洲)',
      AR: 'Argentina(阿根廷)',
      AS: 'American Samoa(美属萨摩亚)',
      AT: 'Austria(奥地利)',
      AU: 'Australia(澳大利亚)',
      AW: 'Aruba(阿鲁巴岛)',
      AX: 'Aland Islands(奥兰群岛)',
      AZ: 'Azerbaijan(阿塞拜疆)',
      BA: 'Bosnia and Herzegovina(波黑)',
      BB: 'Barbados(巴巴多斯岛)',
      BD: 'Bangladesh(孟加拉共和国)',
      BE: 'Belgium(比利时)',
      BF: 'Burkina Faso(布基纳法索)',
      BG: 'Bulgaria(保加利亚)',
      BH: 'Bahrain(巴林)',
      BI: 'Burundi(布隆迪)',
      BJ: 'Benin(贝宁湾)',
      BL: 'Saint Barthélemy(圣巴茨岛)',
      BM: 'Bermuda(百慕大群岛)',
      BN: 'Brunei(文莱)',
      BO: 'Bolivia(玻利维亚)',
      BQ: 'British Antarctic Territory(英属南极领地)',
      BR: 'Brazil(巴西)',
      BS: 'Bahamas(巴哈马群岛)',
      BT: 'Bhutan(不丹)',
      BV: 'Bouvet Island(布韦岛)',
      BW: 'Botswana(博茨瓦纳)',
      BY: 'Belarus(白俄罗斯)',
      BZ: 'Belize(伯利兹)',
      CA: 'Canada(加拿大)',
      CC: 'Cocos Islands(科科斯群岛)',
      CD: 'Congo - Kinshasa(刚果（金）)',
      CF: 'Central African Republic(中非共和国)',
      CG: 'Congo - Brazzaville(刚果布)',
      CH: 'Switzerland(瑞士)',
      CI: "Cote d'Ivoire(科特迪瓦)",
      CK: 'Cook Islands(库克群岛)',
      CL: 'Chile(智利)',
      CM: 'Cameroon(喀麦隆)',
      CO: 'Colombia(哥伦比亚)',
      CR: 'Costa Rica(哥斯达黎加)',
      CS: 'Serbia and Montenegro(塞尔维亚和黑山)',
      CT: 'Canton and Enderbury Islands(广州和利群岛)',
      CU: 'Cuba(古巴)',
      CV: 'Cape Verde(佛得角)',
      CX: 'Christmas Island(圣诞岛)',
      CY: 'Cyprus(塞浦路斯)',
      CZ: 'Czech Republic(捷克)',
      DD: 'East Germany(东德)',
      DE: 'Germany(德国)',
      DJ: 'Djibouti(吉布提)',
      DK: 'Denmark(丹麦)',
      DM: 'Dominica(多米尼加)',
      DO: 'Dominican Republic(多米尼加共和国)',
      DZ: 'Algeria(阿尔及利亚)',
      EC: 'Ecuador(厄瓜多尔)',
      EE: 'Estonia(爱沙尼亚)',
      EG: 'Egypt(埃及)',
      EH: 'Western Sahara(西撒哈拉)',
      ER: 'Eritrea(厄立特里亚)',
      ES: 'Spain(西班牙)',
      ET: 'Ethiopia(埃塞俄比亚)',
      FI: 'Finland(芬兰)',
      FJ: 'Fiji(斐济)',
      FK: 'Falkland Islands(福克兰群岛)',
      FM: 'Micronesia(密克罗尼西亚)',
      FO: 'Faroe Islands(法罗群岛)',
      FQ: 'French Southern and Antarctic Territories(法国南方和南极领地)',
      FR: 'France(法国)',
      FX: 'Metropolitan France(法国本土)',
      GA: 'Gabon(加蓬)',
      GB: 'United Kingdom(UK)(英国)',
      GD: 'Grenada(格林纳达)',
      GE: 'Georgia(格鲁吉亚)',
      GF: 'French Guiana(法属圭亚那)',
      GG: 'Guernsey(根西岛)',
      GH: 'Ghana(加纳)',
      GI: 'Gibraltar(直布罗陀)',
      GL: 'Greenland(格陵兰)',
      GM: 'Gambia(冈比亚)',
      GN: 'Guinea(几内亚)',
      GP: 'Guadeloupe(瓜德罗普岛)',
      GQ: 'Equatorial Guinea(赤道几内亚)',
      GR: 'Greece(希腊)',
      GS: 'South Georgia and the South Sandwich Islands(南乔治亚岛与南桑威奇群岛)',
      GT: 'Guatemala(危地马拉)',
      GU: 'Guam(关岛)',
      GW: 'Guinea-Bissau(几内亚比绍共和国)',
      GY: 'Guyana(圭亚那)',
      HK: 'Hong Kong(中国香港特别行政区)',
      HM: 'Heard Island and McDonald Islands(赫德岛和麦克唐纳岛)',
      HN: 'Honduras(洪都拉斯)',
      HR: 'Croatia(克罗地亚)',
      HT: 'Haiti(海地)',
      HU: 'Hungary(匈牙利)',
      ID: 'Indonesia(印尼)',
      IE: 'Ireland(爱尔兰)',
      IL: 'Israel(以色列)',
      IM: 'Isle of Man(马恩岛)',
      IN: 'India(印度)',
      IO: 'British Indian Ocean Territory(英属印度洋领地)',
      IQ: 'Iraq(伊拉克共和国)',
      IR: 'Iran(伊朗)',
      IS: 'Iceland(冰岛)',
      IT: 'Italy(意大利)',
      JE: 'Jersey(泽西岛)',
      JM: 'Jamaica(牙买加)',
      JO: 'Jordan(约旦)',
      JP: 'Japan(日本)',
      JT: 'Johnston Island(约翰斯顿岛)',
      KE: 'Kenya(肯尼亚)',
      KG: 'Kyrgyzstan(吉尔吉斯斯坦)',
      KH: 'Cambodia(柬埔寨)',
      KI: 'Kiribati(基里巴斯)',
      KM: 'Comoros(科摩罗)',
      KN: 'Saint Kitts and Nevis(圣克里斯托弗和尼维斯岛)',
      KP: 'North Korea(朝鲜)',
      KR: 'South Korea(韩国)',
      KW: 'Kuwait(科威特)',
      KY: 'Cayman Islands(开曼群岛)',
      KZ: 'Kazakhstan(哈萨克斯坦)',
      LA: 'Laos(老挝国)',
      LB: 'Lebanon(黎巴嫩)',
      LC: 'Saint Lucia(圣卢西亚岛)',
      LI: 'Liechtenstein(列支敦斯登)',
      LK: 'Sri Lanka(斯里兰卡)',
      LR: 'Liberia(利比里亚)',
      LS: 'Lesotho(莱索托)',
      LT: 'Lithuania(立陶宛)',
      LU: 'Luxembourg(卢森堡)',
      LV: 'Latvia(拉脱维亚)',
      LY: 'Libya(利比亚)',
      MA: 'Morocco(摩洛哥)',
      MC: 'Monaco(摩纳哥)',
      MD: 'Moldova(摩尔多瓦)',
      ME: 'Montenegro(黑山共和国)',
      MF: 'Saint Martin(圣马丁岛)',
      MG: 'Madagascar(马达加斯加岛)',
      MH: 'Marshall Islands(马绍尔群岛)',
      MI: 'Midway Islands(中途岛)',
      MK: 'Macedonia(马其顿)',
      ML: 'Mali(马里)',
      MM: 'Myanmar(缅甸)',
      MN: 'Mongolia(蒙古)',
      MO: 'Macau(中国澳门特别行政区)',
      MP: 'Northern Mariana Islands(北马里亚纳群岛)',
      MQ: 'Martinique(马提尼克岛)',
      MR: 'Mauritania(毛利塔尼亚)',
      MS: 'Montserrat(蒙特塞拉特岛)',
      MT: 'Malta(马耳他)',
      MU: 'Mauritius(毛里求斯)',
      MV: 'Maldives(马尔代夫)',
      MW: 'Malawi(马拉维)',
      MX: 'Mexico(墨西哥)',
      MY: 'Malaysia(马来西亚)',
      MZ: 'Mozambique(莫桑比克)',
      NA: 'Namibia(纳米比亚)',
      NC: 'New Caledonia(新喀里多尼亚)',
      NE: 'Niger(尼日尔)',
      NF: 'Norfolk Island(诺福克岛)',
      NG: 'Nigeria(尼日利亚)',
      NI: 'Nicaragua(尼加拉瓜)',
      NL: 'Netherlands(荷兰)',
      NO: 'Norway(挪威)',
      NP: 'Nepal(尼泊尔)',
      NQ: 'Dronning Maud Land(毛德皇后地)',
      NR: 'Nauru(瑙鲁)',
      NT: 'Neutral Zone(中立区)',
      NU: 'Niue(纽埃岛)',
      NZ: 'New Zealand(新西兰)',
      OM: 'Oman(阿曼)',
      PA: 'Panama(巴拿马)',
      PC: 'Pacific Islands Trust Territory(太平洋岛屿托管领土)',
      PE: 'Peru(秘鲁)',
      PF: 'French Polynesia(法属玻利尼西亚)',
      PG: 'Papua New Guinea(巴布亚新几内亚)',
      PH: 'Philippines(菲律宾)',
      PK: 'Pakistan(巴基斯坦)',
      PL: 'Poland(波兰)',
      PM: 'Saint Pierre and Miquelon(圣皮埃尔和密克隆)',
      PN: 'Pitcairn(皮特克恩岛)',
      PR: 'Puerto Rico(波多黎各)',
      PS: 'Palestinian Territory(巴勒斯坦领土)',
      PT: 'Portugal(葡萄牙)',
      PU: 'U.S. Miscellaneous Pacific Islands(美控太平洋岛屿)',
      PW: 'Palau(帕劳群岛)',
      PY: 'Paraguay(巴拉圭)',
      PZ: 'Panama Canal Zone(巴拿马运河区)',
      QA: 'Qatar(卡塔尔)',
      QO: 'Outlying Oceania(边远的大洋洲)',
      QU: 'European Union(欧洲联盟)',
      RE: 'Reunion(留尼旺岛)',
      RO: 'Romania(罗马尼亚)',
      RS: 'Serbia(塞尔维亚)',
      RU: 'Russian Federation(俄罗斯)',
      RW: 'Rwanda(卢旺达)',
      SA: 'Saudi Arabia(沙特阿拉伯)',
      SB: 'Solomon Islands(所罗门群岛)',
      SC: 'Seychelles(塞舌尔)',
      SD: 'Sudan(苏丹)',
      SE: 'Sweden(瑞典)',
      SG: 'Singapore(新加坡)',
      SH: 'Saint Helena(圣赫勒拿岛)',
      SI: 'Slovenia(斯洛文尼亚)',
      SJ: 'Svalbard and Jan Mayen(斯瓦尔巴岛和扬马延岛)',
      SK: 'Slovakia(斯洛伐克)',
      SL: 'Sierra Leone(塞拉利昂)',
      SM: 'San Marino(圣马力诺)',
      SN: 'Senegal(塞内加尔)',
      SO: 'Somalia(索马里)',
      SR: 'Suriname(苏里南)',
      ST: 'Sao Tome and Principe(圣多美和普林西比)',
      SU: 'Union of Soviet Socialist Republics(苏联)',
      SV: 'El Salvador(萨尔瓦多)',
      SY: 'Syria(叙利亚)',
      SZ: 'Swaziland(斯威士兰)',
      TC: 'Turks and Caicos Islands(特克斯和凯科斯群岛)',
      TD: 'Chad(乍得湖)',
      TF: 'French Southern Territories(法属南半球领地)',
      TG: 'Togo(多哥)',
      TH: 'Thailand(泰国)',
      TJ: 'Tajikistan(塔吉克斯坦)',
      TK: 'Tokelau(托克劳群岛)',
      TL: 'East Timor(东帝汶)',
      TM: 'Turkmenistan(土库曼斯坦)',
      TN: 'Tunisia(突尼斯)',
      TO: 'Tonga(汤加)',
      TR: 'Turkey(土耳其)',
      TT: 'Trinidad and Tobago(特立尼达和多巴哥)',
      TV: 'Tuvalu(图瓦卢)',
      TW: 'Taiwan(中国台湾地区)',
      TZ: 'Tanzania(坦桑尼亚)',
      UA: 'Ukraine(乌克兰)',
      UG: 'Uganda(乌干达)',
      UM: 'United States Minor Outlying Islands(美国本土外小岛屿)',
      US: 'United States(USA, America)(美国)',
      UY: 'Uruguay(乌拉圭)',
      UZ: 'Uzbekistan(乌兹别克斯坦)',
      VA: 'Vatican(梵蒂冈)',
      VC: 'Saint Vincent and the Grenadines(圣文森特和格林纳丁斯)',
      VD: 'North Vietnam(北越)',
      VE: 'Venezuela(委内瑞拉)',
      VG: 'British Virgin Islands(英属维京群岛)',
      VI: 'U.S. Virgin Islands(美属维尔京群岛)',
      VN: 'Vietnam(越南)',
      VU: 'Vanuatu(瓦努阿图)',
      WF: 'Wallis and Futuna(瓦利斯群岛和富图纳群岛)',
      WK: 'Wake Island(威克岛)',
      WS: 'Samoa(萨摩亚群岛)',
      YD: "People's Democratic Republic of Yemen(也门人民民主共和国)",
      YE: 'Yemen(也门)',
      YT: 'Mayotte(马约特岛)',
      ZA: 'South Africa(南非)',
      ZM: 'Zambia(赞比亚)',
      ZW: 'Zimbabwe(津巴布韦)'
    }
  }
}
